import React from "react";
import { Link } from "react-router-dom";
import ImageCarousel from "../components/ImageCarousel";

const Banner = () => {
  const bannerStyle = {
    background: `linear-gradient(135deg, rgba(3, 102, 214, 0.9) 0%, rgba(2, 86, 204, 0.9) 100%), url('/assets/logo.png') center/cover no-repeat`,
    color: "white",
    textAlign: "center",
    padding: "3rem 2rem",
    marginBottom: "2rem",
    position: "relative",
    overflow: "hidden",
  };

  return (
    <div className="banner" style={bannerStyle}>
      <div className="banner-content">
        <h1>GH Tracker is back!</h1>
        <p>Rewritten and ready to get you back on track</p>
        <div
          style={{
            display: "flex",
            gap: "1rem",
            justifyContent: "center",
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <a
            href="https://apps.apple.com/us/app/gh-tracker/id1171234313"
            className="app-store-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/assets/black.svg" alt="Download on the App Store" />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.kalf.ghinjections"
            className="app-store-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/assets/googleplay.svg" alt="Get it on Google Play" />
          </a>
        </div>
      </div>
    </div>
  );
};

const PromoCard = () => {
  return (
    <div className="promo-card">
      <div className="promo-sparkles">
        <span className="sparkle">✨</span>
        <span className="sparkle">⭐</span>
        <span className="sparkle">🎉</span>
        <span className="sparkle">💫</span>
        <span className="sparkle">✨</span>
        <span className="sparkle">⭐</span>
      </div>
      <div className="promo-card-content">
        <h2 className="promo-title">
          <span className="emoji-bounce">🎁</span> Special Offer{" "}
          <span className="emoji-bounce">🎁</span>
        </h2>
        <p className="promo-text highlight">
          Join the group and we will send you a DM with a promo code for a month
          - leave a comment <span className="holidays">HOLIDAYS</span>
        </p>
        <p className="promo-text highlight">
          Refer others and have them join the group and you can have a month for
          each person!
        </p>
        <div
          style={{
            display: "flex",
            gap: "1rem",
            justifyContent: "center",
            flexWrap: "wrap",
            marginTop: "1rem",
          }}
        >
          <a
            href="https://www.facebook.com/growthhormonetracker/"
            className="promo-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="link-icon">🚀</span> Join Our Facebook Group{" "}
            <span className="link-arrow">→</span>
          </a>
          <a
            href="https://www.tiktok.com/@redcalf01"
            className="promo-link tiktok-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="link-icon">🎵</span> Follow Us on TikTok{" "}
            <span className="link-arrow">→</span>
          </a>
        </div>
      </div>
    </div>
  );
};

const Home = () => {
  const screenshots = [
    "/assets/SChome.png",
    "/assets/SCgrowthChart.png",
    "/assets/SCchart2.png",
    "/assets/SCchangeOrder.png",
    "/assets/SCnextfewdays.png",
    "/assets/SCprogress.png",
    "/assets/SCreminders.png",
  ];

  return (
    <>
      <Banner />
      <div className="container">
        <PromoCard />
      </div>
      <div className="page">
        <h1>Welcome to GH Tracker</h1>

        <p>
          GH Tracker is a powerful application designed to help you track and
          monitor growth hormone therapy progress. Whether you're managing your
          own treatment or helping a loved one, GH Tracker provides the tools
          and insights you need to stay organized and track progress
          effectively.
        </p>

        <div className="screenshots-research-container">
          <div className="screenshots-section">
            <h2 style={{ fontSize: "1.2rem", marginBottom: "0.3rem" }}>
              Screenshots
            </h2>
            <ImageCarousel images={screenshots} />
          </div>

          <div className="study-banner">
            <div className="study-banner-content">
              <h2>🔬 Research Validated</h2>
              <p>
                <strong>GH Tracker was used in a study</strong> - Our app has
                been validated in scientific research, demonstrating its
                effectiveness in growth hormone therapy tracking.
              </p>
              <a
                href="https://pmc.ncbi.nlm.nih.gov/articles/PMC7055837/"
                className="study-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Read the Research Study →
              </a>
            </div>
          </div>
        </div>

        <h2>What is GH Tracker?</h2>
        <p>
          GH Tracker is a comprehensive growth hormone tracking platform that
          allows you to:
        </p>

        <div className="feature-grid">
          <div className="feature-card">
            <h3>📊 Growth Analytics</h3>
            <p>
              Get detailed insights into your growth progress, including height
              and weight trends, growth velocity, and percentile tracking.
            </p>
          </div>

          <div className="feature-card">
            <h3>📝 Easy Data Entry</h3>
            <p>
              Quickly log your measurements, dosage information, and treatment
              notes with an intuitive interface designed for daily use.
            </p>
          </div>

          <div className="feature-card">
            <h3>📈 Progress Tracking</h3>
            <p>
              Monitor your growth progress with visual charts and reports that
              help you understand your treatment effectiveness over time.
            </p>
          </div>

          <div className="feature-card">
            <h3>📸 Photo Documentation</h3>
            <p>
              Attach photos to track visual progress over time, with all images
              stored securely on your device for privacy.
            </p>
          </div>

          <div className="feature-card">
            <h3>🔔 Treatment Reminders</h3>
            <p>
              Set up smart reminders for medication doses and measurement
              schedules to help maintain consistent tracking.
            </p>
          </div>

          <div className="feature-card">
            <h3>📱 Cross-Platform Access</h3>
            <p>
              Access your growth data from anywhere with our responsive
              interface that works seamlessly on desktop and mobile devices.
            </p>
          </div>
        </div>

        <h2>Getting Started</h2>
        <p>
          Ready to start tracking your growth hormone therapy progress? GH
          Tracker makes it easy to begin logging your measurements and
          monitoring your treatment journey immediately.
        </p>

        <div
          style={{
            marginTop: "2rem",
            textAlign: "center",
            display: "flex",
            gap: "1rem",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <Link to="/privacy" className="btn">
            View Privacy Policy
          </Link>
          <Link to="/eula" className="btn btn-secondary">
            View EULA
          </Link>
        </div>

        <h2>Why Choose GH Tracker?</h2>
        <p>
          Unlike basic tracking methods, GH Tracker is specifically designed for
          individuals and families managing growth hormone therapy. Our platform
          combines intuitive data entry with comprehensive analytics and
          privacy-focused design to give you a complete picture of your
          treatment progress.
        </p>

        <p>
          Whether you're tracking your own growth hormone therapy or helping a
          family member, GH Tracker provides the tools and insights you need to
          stay organized and monitor progress effectively throughout your
          treatment journey.
        </p>
      </div>
    </>
  );
};

export default Home;
